import scroller from "../component/design-system/react-scroll/mixins/scroller";

export function scrollTo(el: any, options = {
  duration: 500,
  delay: 50,
  smooth: true,
  offset: -130,
}) {
  scroller.scrollTo(el, options);
}

export function scrollToTop() {
  try {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  } catch (err) {
    window.scrollTo(0, 0);
  }
}
